export enum NetworkSpeed {
  SLOW = 'slow',
  FAST = 'fast',
  UNKNOWN = 'unknown',
}

export const getNetworkSpeed = () => {
  if (typeof navigator === 'undefined') return NetworkSpeed.UNKNOWN;
  const connection =
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;

  if (!connection) return NetworkSpeed.UNKNOWN;

  switch (connection.effectiveType) {
    case 'slow-2g':
    case '2g':
    case '3g':
      return NetworkSpeed.SLOW;
    case '4g':
      return NetworkSpeed.FAST;
    default:
      return NetworkSpeed.UNKNOWN;
  }
};
